<div class="d-flex gap-2 align-items-center px-4">
  <a (click)="bsModalRef.hide()">
    <app-svg-icon type="tiles" size="large"/>
  </a>
  <h2 class="modal-title">{{ 'openProjectComponent.label.import' | translate }}</h2>
</div>
<p class="pb-4 px-4">{{ 'openProjectComponent.label.actions_descriptions' | translate }}</p>
<div class="mx-3 flex-grow-1 align-items stretch">
  <div class="py-2">
    <div class="hero">
      <div class="hero-content">

        <div class="category-wrapper">
          <div class="side-spacer">
            <h3>{{ 'importChoice.local_files' | translate }}</h3>
          </div>

          <div class="tiles-container">
            @if (enabledEntries?.get('cae')) {
              <app-tile-button
                icon="project-import" data-gatm="openProject.cae_import" [attr.data-testid]="'import-cae'"
                (click)="actionWithCae()" id="import_cae_file"
                [text]="'importChoice.import.cae' | translate"
                appActionLogId="import.cae.from-dashboard">
              </app-tile-button>
            }
            @if (enabledEntries?.get('csv')) {
              <app-tile-button
                icon="maintenance" data-gatm="openProject.csv_import" [attr.data-testid]="'import-csv'"
                (click)="actionWithCsv()" id="import_csv_file"
                [text]="'importChoice.import.csv' | translate"
                appActionLogId="import.csv.from-dashboard">
              </app-tile-button>
            }
            @if (enabledEntries?.get('localBackup')) {
              <app-tile-button
                icon="configuration"
                data-gatm="openProject.import_from_backup"
                [attr.data-testid]="'import-wsp'"
                (click)="actionWithWsp()" id="import_wsp_file"
                [text]="'importChoice.import.wsp' | translate"
                appActionLogId="import.wsp.from-dashboard">
              </app-tile-button>
            }
            @if (enabledEntries?.get('proserve')) {
              <app-tile-button
                icon="configuration"
                data-gatm="openProject.import_old_project"
                [attr.data-testid]="'import-proserve'"
                (click)="actionWithProServe()" id="import_old_project"
                [text]="'importChoice.import.proserve' | translate"
                appActionLogId="import.proserve.from-dashboard">
              </app-tile-button>
            }
          </div>
        </div>

        <div class="category-wrapper">
          <div class="side-spacer">
            <h3>{{ 'importChoice.cae_apis' | translate }}</h3>
          </div>
          <div class="tiles-container">

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/eplan.svg"
                id="cae_eplan"
                [text]="'importChoice.cae_api.eplan' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.eplan' | translate}}</h4>
                  <a [href]="'importChoice.cae_api.eplan.interface.link' | translate" appActionLogId="cae_api_link.eplan.interface" target="_blank" rel="noopener">
                    <app-svg-icon type="download_direct"/><strong>{{ 'importChoice.cae_api.eplan.interface' | translate }}</strong>
                  </a>
                <a [href]="'importChoice.cae_api.eplan.manual.link' | translate" appActionLogId="cae_api_link.eplan.manual" target="_blank" rel="noopener">
                  <app-svg-icon type="book"/><strong>{{ 'importChoice.interface_manual' | translate }}</strong>
                </a>
                  <a [href]="'importChoice.cae_api.eplan.article_data.link' | translate" appActionLogId="cae_api_link.eplan.article_data" target="_blank" rel="noopener">
                    <app-svg-icon type="writing-board"/><strong>{{ 'importChoice.cae_api.article_data' | translate }}</strong>
                  </a>
                  <a [href]="'importChoice.cae_api.eplan.more_info.link' | translate" appActionLogId="cae_api_link.eplan.more_info" target="_blank" rel="noopener">
                    <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                  </a>
              </div>
            </div>

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/wscad.svg"
                id="cae_wscad"
                [text]="'importChoice.cae_api.wscad' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.wscad' | translate}}</h4>
                  <a [href]="'importChoice.cae_api.wscad.article_data.link' | translate" appActionLogId="cae_api_link.wscad.article_data" target="_blank" rel="noopener">
                    <app-svg-icon type="writing-board"/><strong>{{ 'importChoice.cae_api.article_data' | translate }}</strong>
                  </a>
                  <a [href]="'importChoice.cae_api.wscad.more_info.link' | translate" appActionLogId="cae_api_link.wscad.more_info" target="_blank" rel="noopener">
                    <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                  </a>
              </div>
            </div>

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/zuken.svg"
                id="cae_zuken"
                [text]="'importChoice.cae_api.zuken' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.zuken' | translate}}</h4>
                  <a [href]="'importChoice.cae_api.zuken.e3_interface.link' | translate" appActionLogId="cae_api_link.zuken.e3_interface" target="_blank" rel="noopener">
                    <app-svg-icon type="download_direct"/><strong>{{ 'importChoice.cae_api.zuken.e3_interface' | translate }}</strong>
                  </a>
                  <a [href]="'importChoice.cae_api.zuken.article_data.link' | translate" appActionLogId="cae_api_link.zuken.article_data" target="_blank" rel="noopener">
                    <app-svg-icon type="writing-board"/><strong>{{ 'importChoice.cae_api.article_data' | translate }}</strong>
                  </a>
                  <a [href]="'importChoice.cae_api.zuken.more_info.link' | translate" appActionLogId="cae_api_link.zuken.more_info" target="_blank" rel="noopener">
                    <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                  </a>
              </div>
            </div>

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/strieplan.webp"
                id="cae_strieplan"
                [text]="'importChoice.cae_api.strieplan' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.strieplan' | translate}}</h4>
                <a [href]="'importChoice.cae_api.strieplan.manual.link' | translate" appActionLogId="cae_api_link.strieplan.manual" target="_blank" rel="noopener">
                  <app-svg-icon type="book"/><strong>{{ 'importChoice.interface_manual' | translate }}</strong>
                </a>
                <a [href]="'importChoice.cae_api.strieplan.article_data.link' | translate" appActionLogId="cae_api_link.strieplan.article_data" target="_blank" rel="noopener">
                  <app-svg-icon type="writing-board"/><strong>{{ 'importChoice.cae_api.article_data' | translate }}</strong>
                </a>
                <a [href]="'importChoice.cae_api.strieplan.more_info.link' | translate" appActionLogId="cae_api_link.strieplan.more_info" target="_blank" rel="noopener">
                  <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                </a>
              </div>
            </div>

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/SEEelectrical.png"
                id="see-electrical"
                [text]="'importChoice.cae_api.see_electrical' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.see_electrical' | translate}}</h4>
                <a [href]="'importChoice.cae_api.see_electrical.more_info.link' | translate" appActionLogId="cae_api_link.see_electrical.more_info" target="_blank" rel="noopener">
                  <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                </a>
              </div>
            </div>

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/SDproget.png"
                id="sd-proget"
                [text]="'importChoice.cae_api.sd_proget' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.sd_proget' | translate}}</h4>
                <a [href]="'importChoice.cae_api.sd_proget.article_data.link' | translate" appActionLogId="cae_api_link.sd_proget.article_data" target="_blank" rel="noopener">
                  <app-svg-icon type="writing-board"/><strong>{{ 'importChoice.cae_api.article_data' | translate }}</strong>
                </a>
                <a [href]="'importChoice.cae_api.sd_proget.more_info.link' | translate" appActionLogId="cae_api_link.sd_proget.more_info" target="_blank" rel="noopener">
                  <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                </a>
              </div>
            </div>

            <div class="tile-button-onclick-container">
              <app-tile-button
                imageUrl="ng-assets/img/tool-icons/autocad.png"
                id="cad_autocad"
                [text]="'importChoice.cae_api.autocad' | translate">
              </app-tile-button>
              <div class="tile-button-onclick-content">
                <h4>{{'importChoice.cae_api.autocad' | translate}}</h4>
                <a [href]="'importChoice.cae_api.autocad.more_info.link' | translate" appActionLogId="importChoice.cae_api.autocad.more_info" target="_blank" rel="noopener">
                  <app-svg-icon type="external-link"/><strong>{{ 'importChoice.more_info' | translate }}</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-forward btn-secondary btn-cancel" (click)="bsModalRef.hide()">{{ 'global.label.cancel' | translate }}</button>
</div>

